import common from './common'

const telPhoneByNumber = (phoneNumber) => {
    try {
        if( !phoneNumber ) {
            return
        }
        // 安卓
        if( !common?.isAndroid_ios() ) {
            if( !!window?.androidNative?.telPhoneByNumber ) {
                window?.androidNative?.telPhoneByNumber(phoneNumber)
            }
        }else {
            if( window?.webkit?.messageHandlers?.telPhoneByNumber ) {
                window?.webkit.messageHandlers.telPhoneByNumber.postMessage(phoneNumber)
            }
        }
    } catch (error) {
        
    }
}

export default telPhoneByNumber
